const offices = ["edental", "Toothlens-Inc", "Banning-dental","Benepower"]

export const dentalOfficeName = offices.includes(window.location.pathname?.split('/')[1]) ? window.location.pathname?.split('/')[1] : "Toothlens-Inc"


